import { useEffect, useState, type FormEvent } from 'react';
import { navLinks, tickerItems } from '@/mocks/home';
import { useDemoToast } from '@/components/feature/DemoToast';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState('');
  const { show } = useDemoToast();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    show(trimmed ? `正在检索「${trimmed}」相关合集（演示）` : '请输入想看的关键词（演示）');
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-primary-700 text-background-50">
        <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4 px-4 py-2 md:px-6">
          <div className="flex items-center gap-2 text-xs">
            <span className="flex h-4 w-4 items-center justify-center text-accent-300">
              <i className="ri-fire-line text-sm"></i>
            </span>
            <span className="whitespace-nowrap">今日已更新 26 组合集</span>
          </div>
          <div className="hidden min-w-0 flex-1 overflow-hidden lg:block">
            <div className="flex w-max hll-marquee">
              {[0, 1].map((loop) => (
                <div key={loop} className="flex shrink-0 items-center">
                  {tickerItems.map((item) => (
                    <span key={`${loop}-${item}`} className="mx-6 whitespace-nowrap text-xs text-background-100">
                      {item}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="hidden items-center gap-4 text-xs text-background-100 md:flex">
            <span className="cursor-pointer whitespace-nowrap transition-colors hover:text-background-50">投稿爆料</span>
            <span className="cursor-pointer whitespace-nowrap transition-colors hover:text-background-50">素材索引</span>
            <span className="cursor-pointer whitespace-nowrap transition-colors hover:text-background-50">说明</span>
          </div>
        </div>
      </div>

      <div
        className={`w-full border-b backdrop-blur transition-colors ${
          scrolled ? 'border-background-300/80 bg-background-50/95' : 'border-background-200/70 bg-background-50'
        }`}
      >
        <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-water-flash-line text-xl"></i>
            </div>
            <div className="leading-tight">
              <p className="font-heading text-lg font-bold tracking-tight text-foreground-950">黑料吃瓜网</p>
              <p className="hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">HEILIAO · 合集档案馆</p>
            </div>
          </div>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden items-center md:flex">
              <div className="flex items-center rounded-full border border-background-300 bg-background-50 pl-3 pr-1">
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-sm"></i>
                </span>
                <input
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  type="text"
                  placeholder="搜合集 / 关键词"
                  className="w-32 bg-transparent px-2 py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-40"
                />
                <button
                  type="submit"
                  className="cursor-pointer whitespace-nowrap rounded-full bg-foreground-900 px-3 py-1.5 text-xs text-background-50 transition-colors hover:bg-foreground-700"
                >
                  搜索
                </button>
              </div>
            </form>
            <a
              href="#resource"
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-2-line text-base"></i>
              </span>
              资源下载
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="打开导航菜单"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
            >
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <div className="mx-auto grid w-full max-w-[1280px] grid-cols-2 gap-2 px-4 py-4 md:px-6">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}